const RoundedCheckIcon = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16" cy="16" r="16" fill="#5B36F2"/>
            <path d="M23.25 11.25C22.9167 10.9167 22.4167 10.9167 22.0833 11.25L13.5 19.8333L9.91667 16.25C9.58333 15.9167 9.08333 15.9167 8.75 16.25C8.41667 16.5833 8.41667 17.0833 8.75 17.4167L12.9167 21.5833C13.0833 21.75 13.25 21.8333 13.5 21.8333C13.75 21.8333 13.9167 21.75 14.0833 21.5833L23.25 12.4167C23.5833 12.0833 23.5833 11.5833 23.25 11.25Z" fill="white"/>
        </svg>
    );
}

export default RoundedCheckIcon;